import React from "react";
import "../Separador NavBar/Separador.css";

function Separar(){
    return(
        <div className="separador">

        </div>
    );
};

export default Separar;